export default __webpack_public_path__ + "images/legend-osm.png";